"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = require("../../../../components");

var _LatestBulkLoads = _interopRequireDefault(require("../components/LatestBulkLoads"));

var _BulkLoadModel = _interopRequireDefault(require("../models/BulkLoadModel"));

var _BulkLoadInfo = _interopRequireDefault(require("../components/BulkLoadInfo"));

var _BulkLoadRecords = _interopRequireDefault(require("../components/BulkLoadRecords"));

var _BreadcrumbHelper = _interopRequireDefault(require("../../../../util/BreadcrumbHelper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var BulkLoadDetails = /*#__PURE__*/function (_React$Component) {
  _inherits(BulkLoadDetails, _React$Component);

  function BulkLoadDetails(props) {
    var _this;

    _classCallCheck(this, BulkLoadDetails);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BulkLoadDetails).call(this, props));

    _BreadcrumbHelper["default"].setCrumbs([{
      label: 'Bulk Load',
      link: '/tools/bulk-load'
    }]);

    return _this;
  }

  _createClass(BulkLoadDetails, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._startPooling();
    }
  }, {
    key: "_startPooling",
    value: function _startPooling() {
      var _this2 = this;

      setTimeout(function () {
        _this2._pool();
      }, 2000);
    }
  }, {
    key: "_pool",
    value: function _pool() {
      var _this3 = this;

      if (this._fetcher) {
        var record = this._fetcher.getRecord();

        if (record && record.status != 'processing') return;

        this._fetcher.refresh(true);

        if (this._table) {
          this._table._refresh(true, true);
        }
      }

      setTimeout(function () {
        _this3._pool();
      }, 5000);
    }
  }, {
    key: "_renderContent",
    value: function _renderContent(item) {
      var _this4 = this;

      if (!this.firstLoad) {
        _BreadcrumbHelper["default"].addCrumb(item.name);

        this.firstLoad = true;
      }

      return _react["default"].createElement(_components.AppPage, {
        title: 'Load Details',
        icon: 'info'
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-sm-4"
      }, _react["default"].createElement(_components.AppWidget, {
        title: item.name,
        icon: null,
        padded: true
      }, _react["default"].createElement(_BulkLoadInfo["default"], {
        bulkLoad: item
      }))), _react["default"].createElement("div", {
        className: "col-sm-8"
      }, _react["default"].createElement(_components.AppWidget, {
        title: "Bulk load items",
        icon: 'list'
      }, _react["default"].createElement(_BulkLoadRecords["default"], {
        bulkLoad: item,
        onInit: function onInit(ref) {
          return _this4._table = ref;
        }
      })))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return _react["default"].createElement(_components.AppFetcher, {
        ref: function ref(fetcher) {
          return _this5._fetcher = fetcher;
        },
        model: _BulkLoadModel["default"],
        id: this.props.match.params.id,
        renderContent: function renderContent(record) {
          return _this5._renderContent(record);
        }
      });
    }
  }]);

  return BulkLoadDetails;
}(_react["default"].Component);

exports["default"] = BulkLoadDetails;